export default "__VITE_ASSET__MXhnjnBq__"